var map = {
	"./admin.svg": 50747,
	"./audit.svg": 24327,
	"./auditlogs.svg": 39210,
	"./debug-permissions.svg": 27316,
	"./dpwtstats.svg": 74716,
	"./encoders.svg": 4293,
	"./event-analytics.svg": 68845,
	"./icons-new/arrow-right-long.svg": 28922,
	"./icons-new/audio-speaker.svg": 89923,
	"./icons-new/audio-wave.svg": 40219,
	"./icons-new/bell.svg": 96100,
	"./icons-new/broadcast-custom.svg": 58588,
	"./icons-new/check.svg": 91945,
	"./icons-new/chevron-down.svg": 63373,
	"./icons-new/clipbin.svg": 67220,
	"./icons-new/close.svg": 11653,
	"./icons-new/delete.svg": 10522,
	"./icons-new/download.svg": 55487,
	"./icons-new/edit.svg": 67767,
	"./icons-new/file.svg": 27213,
	"./icons-new/filter.svg": 57225,
	"./icons-new/folder.svg": 34291,
	"./icons-new/fullscreen.svg": 44324,
	"./icons-new/image.svg": 70394,
	"./icons-new/info.svg": 92027,
	"./icons-new/input.svg": 43021,
	"./icons-new/list.svg": 46111,
	"./icons-new/loading.svg": 19337,
	"./icons-new/logout.svg": 67661,
	"./icons-new/loop.svg": 94149,
	"./icons-new/more.svg": 55180,
	"./icons-new/opening-times.svg": 4336,
	"./icons-new/output.svg": 36816,
	"./icons-new/peakmeter.svg": 78213,
	"./icons-new/permissions.svg": 50829,
	"./icons-new/play.svg": 37277,
	"./icons-new/plus.svg": 14195,
	"./icons-new/question.svg": 88875,
	"./icons-new/record.svg": 76136,
	"./icons-new/refresh.svg": 26472,
	"./icons-new/reload.svg": 86816,
	"./icons-new/right-arrow.svg": 81375,
	"./icons-new/route.svg": 3046,
	"./icons-new/stop.svg": 3395,
	"./icons-new/tasks.svg": 67851,
	"./icons-new/time.svg": 75120,
	"./icons-new/transcript.svg": 14613,
	"./icons-new/upload.svg": 91744,
	"./icons-new/url.svg": 35398,
	"./icons-new/user-add.svg": 8680,
	"./icons-new/user.svg": 79234,
	"./icons-new/warning-2.svg": 9632,
	"./icons-new/warning.svg": 2537,
	"./icons/fonts/blishly.svg": 48405,
	"./icons/update/fonts/ma.svg": 54828,
	"./liveops.svg": 74772,
	"./mam.svg": 48761,
	"./mgw.svg": 73465,
	"./monitor.svg": 46532,
	"./multiview.svg": 81890,
	"./multiviewer.svg": 88651,
	"./multiviewernew.svg": 66903,
	"./mv.svg": 16907,
	"./mvr.svg": 2451,
	"./newFile.svg": 44502,
	"./permissionssimple.svg": 70848,
	"./probes.svg": 85479,
	"./reports.svg": 36107,
	"./router.svg": 48929,
	"./routeralt.svg": 87226,
	"./schedule-status-legend.svg": 9362,
	"./schedule.svg": 23637,
	"./scheduleagenda.svg": 14197,
	"./servers.svg": 59406,
	"./sourcemonitoring.svg": 78339
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91980;